import {Axios as http} from '../axios/axios'

export const getRedemptionList = (data) => {
  return http({
    url:"/adminapi/getRwordList",
    method:'POST',
    data: data
  })
}

export const createRedemption = (data) => {
  return http({
    url: '/adminapi/addReword',
    method:'POST',
    data: data
  })
}

export const editRedemption = (data) => {
  return http({
    url: '/adminapi/editReword',
    method:'POST',
    data: data
  })
}
export const getCouponList= (data) => {
  return http({
    url: '/adminapi/getCouponDropdown',
    method:'POST',
    data: data
  })
}

export const deleteRedemption = (data) => {
  return http({
    url: '/adminapi/DelReword',
    method:'POST',
    data: data
  })
}

export const getRedemptionHistory = (data) => {
  return http({
    url: '/adminapi/getRwordLogList',
    method:'POST',
    data: data
  })
}

export const updateRedemptionStatus = (data) => {
  return http({
    url: '/adminapi/updateRewardStatus',
    method:'POST',
    data: data
  })
}
//兑换处理列表 adminapi/getRedemptionRequests
export const getRedemptionRequests = (data) => {
  return http({
    url: '/adminapi/getRedemptionRequests',
    method:'POST',
    data: data
  })
}
// 修改处理状态 adminapi/updateRedemptionRequest
export const updateRedemptionRequest = (data) => {
  return http({
    url: '/adminapi/updateRedemptionRequest',
    method:'POST',
    data: data
  })
}
//获取待处理数量 adminapi/getRedemptionRequestCount
export const getRedemptionRequestCount = (data) => {
  return http({
    url: '/adminapi/getRedemptionRequestCount',
    method:'POST',
    data: data
  })
}
